const features = [
  {
    icon: 'ri-timer-flash-line',
    title: 'Fast Placements',
    description: 'We maintain a deep bench of pre-vetted talent ready to start when you need them.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Industry Expertise',
    description: 'Our specialists know your field inside and out, so they understand exactly what skills matter most.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Personal Service',
    description: 'You\'ll work with a dedicated account manager who knows you and your business.',
  },
];

export default function WhyUsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-8 md:px-14">

        {/* Section header — rack card style with left accent */}
        <div className="flex items-start gap-5 mb-16">
          <div className="w-1 bg-[#c8a84b] self-stretch rounded-full shrink-0" style={{ minHeight: '60px' }} />
          <div>
            <p
              className="text-[#c8a84b] text-xs font-bold tracking-[0.3em] uppercase mb-2"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Why Work With Us
            </p>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-[#1a3a3a] leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Flexible Staffing Solutions
              <br />
              <em className="not-italic text-[#c8a84b]">So You Can Focus on Running Your Business</em>
            </h2>
          </div>
        </div>

        {/* 3-column icon cards — rack card layout */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gray-100 rounded-lg overflow-hidden mb-16">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-white p-10 flex flex-col items-center text-center group hover:bg-[#f8f7f2] transition-colors duration-200"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-[#1a3a3a]/15 mb-6 group-hover:border-[#c8a84b] transition-colors duration-200">
                <i className={`${f.icon} text-2xl text-[#1a3a3a] group-hover:text-[#c8a84b] transition-colors duration-200`} />
              </div>
              <h3
                className="text-base font-extrabold text-[#1a3a3a] mb-3"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {f.title}
              </h3>
              <p
                className="text-gray-500 text-sm leading-relaxed"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {f.description}
              </p>
            </div>
          ))}
        </div>

        {/* Italic quote — rack card style */}
        <div className="bg-[#f8f7f2] border-l-4 border-[#c8a84b] rounded-r-lg px-8 py-6 max-w-2xl mx-auto text-center">
          <p
            className="text-[#1a3a3a] text-lg italic font-medium leading-relaxed"
            style={{ fontFamily: "'Georgia', serif" }}
          >
            &ldquo;We take the headache out of temporary staffing so you can focus on running your business.&rdquo;
          </p>
        </div>
      </div>
    </section>
  );
}
